// Presentational bits shared by the topbar search dropdown and the /search
// results page, so results look and read the same on both surfaces.
import { BuildingIcon, MarketMapIcon, LeadQualityIcon, HashIcon } from './icons.jsx'
import { splitHighlight } from '../lib/appSearch.js'

const ICONS = {
  lead: BuildingIcon,
  market: MarketMapIcon,
  segment: LeadQualityIcon,
  page: HashIcon,
}

export function ResultIcon({ icon, className }) {
  const Ic = ICONS[icon] || HashIcon
  return <Ic className={className} />
}

// Renders `text`, bolding every case-insensitive occurrence of `query`.
export function Highlight({ text, query }) {
  return splitHighlight(text, query).map((seg, i) =>
    seg.hit ? (
      <strong key={i} className="font-bold">
        {seg.text}
      </strong>
    ) : (
      <span key={i}>{seg.text}</span>
    ),
  )
}
